import {Link} from 'react-router-dom';
import { useState } from "react";
import api5 from './api5';
import { usePWAInstall } from "../usePWAInstall";

function  FooterHomepage(){    
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const { install } = usePWAInstall();

     const socialLinks = [
          {
            name: "X",
            url: "https://x.com/kadhr_africa",
            color: "#000000", // X (formerly Twitter)
            icon: (
                <path d="M18.244 2H21.556L14.323 10.217L22.8 22H16.155L10.942 14.845L4.674 22H1.36L9.096 13.183L1 2H7.79L12.503 8.574L18.244 2ZM17.082 20H18.92L6.79 4H4.82L17.082 20Z" />
            ),
          },
          {
            name: "Instagram",
            url: "https://instagram.com/kadhrafrica",
            color: "#E4405F", // Instagram Pinkish Red
            icon: <path d="M7 2c-2.8 0-5 2.2-5 5v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm8 2a1 1 0 011 1v1a1 1 0 01-2 0V5a1 1 0 011-1zm-5 3a5 5 0 015 5 5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5zm0 2a3 3 0 100 6 3 3 0 000-6z" />,
          },
          {
            name: "LinkedIn",
            url: "https://www.linkedin.com/company/kadhrafrica",
            color: "#0077B5", // LinkedIn Blue
            icon: <path d="M16 8a6 6 0 00-6 6v6h4v-6a2 2 0 114 0v6h4v-6a6 6 0 00-6-6zM2 9h4v12H2V9zm2-5a2 2 0 110 4 2 2 0 010-4z" />,
          },
          {
            name: "YouTube",
            url: "https://www.youtube.com/@kadhrafrica",
            color: "#FF0000", // YouTube Red
            icon: <path d="M21.8 8s-.2-1.4-.8-2a3.7 3.7 0 00-2-1.4C16.7 4 12 4 12 4s-4.7 0-7 .6a3.7 3.7 0 00-2 1.4c-.6.6-.8 2-.8 2S2 9.7 2 11.5v1c0 1.8.2 3.5.2 3.5s.2 1.4.8 2a3.7 3.7 0 002 1.4c2.3.6 7 .6 7 .6s4.7 0 7-.6a3.7 3.7 0 002-1.4c.6-.6.8-2 .8-2s.2-1.7.2-3.5v-1c0-1.8-.2-3.5-.2-3.5zm-12 6.7V9.3l5.3 2.7-5.3 2.7z" />,
          },
    ];
     const handleSubscribe = async () => {
        setLoading(true);
        setMessage('');
        if (!email) {
            setMessage("Kindly enter an email address.");
            return;
        }

        try {
            const response = await api5.post(baseUrl+"/subscribe/", { email });
            setMessage(response.data.message);
            setEmail(""); // Clear input
            setLoading(false);
        } catch (error) {
            setMessage("Subscription failed. Please try again.");
            setLoading(false);
        }
    };
    const year0 = new Date().getFullYear();
    return (
        <div className="pt-5 mb-0 bg-light pt-6indx0">
            <div className='container'>
            <div className="row">
                <div className="col-12 col-md-3 mb-3">
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2 font-bold">Features</li>
                        <li className="nav-item mb-2"><Link to="/sales-customer-capture" className="nav-link p-0 text-body-secondary">Sales & Customer Capture</Link></li>
                        <li className="nav-item mb-2"><Link to="/customer-memory" className="nav-link p-0 text-body-secondary">Customer Memory</Link></li>
                        <li className="nav-item mb-2"><Link to="/repeat-revenue-agent" className="nav-link p-0 text-body-secondary">AI Relationship Messaging</Link></li>
                        <li className="nav-item mb-2"><Link to="/payments" className="nav-link p-0 text-body-secondary">Payments That Just Work</Link></li>
                        <li className="nav-item mb-2"><Link to="/repeat-revenue-agent" className="nav-link p-0 text-body-secondary">Repeat Revenue Agent</Link></li>
                    </ul>
                </div>

                <div className="col-12 col-md-2 mb-3">
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2 font-bold">Resources</li>
                        <li className="nav-item mb-2"><Link to="/woocommerce-plugin" className="nav-link p-0 text-body-secondary">Woocommerce Plugin</Link></li>
                        <li className="nav-item mb-2">
                            <button
                                onClick={install}
                                className="nav-link p-0 text-body-secondary border-0 bg-transparent"
                                style={{ cursor: "pointer" }}
                            >
                                Install Kadhr App
                            </button>
                        </li>
                        <li className="nav-item mb-2"><Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="nav-link p-0 text-body-secondary">Tutorials</Link></li>
                        <li className="nav-item mb-2"><Link to="/help-center" className="nav-link p-0 text-body-secondary">Help Center</Link></li>
                        <li className="nav-item mb-2"><Link to="https://blog.kadhr.com" target='_blank' className="nav-link p-0 text-body-secondary">Blog</Link></li>
                    </ul>
                </div>

                <div className="col-12 col-md-2 mb-3">
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2 font-bold">Company</li>
                        <li className="nav-item mb-2"><Link to="/about" className="nav-link p-0 text-body-secondary">About Kadhr</Link></li>
                        <li className="nav-item mb-2"><Link to="/careers" className="nav-link p-0 text-body-secondary">Careers</Link></li>
                        <li className="nav-item mb-2"><Link to="/affiliate" className="nav-link p-0 text-body-secondary">Affiliate program</Link></li>
                        <li className="nav-item mb-2"><Link to="/terms" className="nav-link p-0 text-body-secondary">Terms of Service</Link></li>
                        <li className="nav-item mb-2"><Link to="/privacy" className="nav-link p-0 text-body-secondary">Privacy Policy</Link></li>
                        
                    </ul>
                </div>

                <div className="col-12 col-md-5 mb-3">
                    <form>
                        <h5><b>Subscribe to our newsletter</b></h5>
                        <p className='font8 grey-text'>Monthly digest of what's new and exciting from us.</p>
                        <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                            <label htmlFor="newsletter1" className="visually-hidden">Email address</label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            { loading === true ? <><button className="btn btn-primary" type="button" disabled>Loading...</button></> : <><button className="btn btn-primary" type="button" onClick={handleSubscribe}>Subscribe</button></>}
                            
                            
                        </div>
                        {message && <p className="text-primary mt-2">{message}</p>}
                    </form>
                </div>
            </div>

            <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top font9 companytagline">
                <p>© {year0} Kadhr Africa Ltd. All rights reserved.</p>
                <ul className="list-unstyled d-flex">
                    {socialLinks.map((social,index) => (
                        <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={social.name}
                        className="transition duration-300 me-4"
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill={social.color} // Assign brand color
                            viewBox="0 0 24 24"
                            className="w35"
                        >
                            {social.icon}
                        </svg>
                        </a>
                    ))}
                </ul>
            </div>

            </div>
        </div>
    )
}

export default FooterHomepage;
